// extracted by mini-css-extract-plugin
export var action = "styles-module--action--489a2";
export var bounce = "styles-module--bounce--0fa1a";
export var pulse = "styles-module--pulse--d1989";